import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { environment } from '../../../environments/environment';
import { Product } from "../../shared/classes/product";
import { ProductService } from "../../shared/services/product.service";
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB, RESPONSE, AppInfo, EitUrl, EitEnv } from '../../shared/services/env.service';
import { TypeOrder, ET_TipoConsegna, ET_TipoOraConsegna } from '../../shared/services/config-app';
import { CouponModalComponent } from '../../shared/components/modal/coupon-modal/coupon-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ExtrainfoComponent } from '../../shared/components/modal/extrainfo/extrainfo.component';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {


  public themeLogo: string = 'assets/images/eatintime-logo.png'; // Change Logo
  public amount: any;
  public location: any = null;
  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public tipoConsegna: any = ET_TipoConsegna;
  public tipoOra: any = ET_TipoOraConsegna;
  appInfo: any = AppInfo;
  public restaurant: any = {};

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private modalService: NgbModal,
    public productService: ProductService,  private toastService: ToastrService, private api: ApiService, public auth: AuthService,
    private cartService: CartService) {
    this.cartData = new EitCart();

    console.log("href: ",window.location.href);
    this.cartService.cartObs.subscribe(x => {

      this.cartData = x;
      if(this.cartData) console.log(this.cartData)

    });

    this.restaurant = JSON.parse(localStorage.getItem(DB.ACTIVITY_BASE));
    var loc = JSON.parse(localStorage.getItem(DB.LOCATION));

    if (loc) {
      this.location = loc;
    } else {
      //popup
    }
  }

  ngOnInit(): void {


    if (this.auth.currentUserValue) {
        
      // authorised 
      
    }else{
      //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

      this.route.queryParams.subscribe(params => {
        console.log(params); 
        if (params && params.token){
          let JWToken = params.token;
          console.log("JWTToken: ", JWToken); 

          var data: any = {};
          data.externaltoken = JWToken;
          this.api.postj("user/security/logingulliver", data, "").subscribe(res => {
            if (res[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK ) {
              this.auth.next(res[RESPONSE.JP_RESULT]);
            }
          });
        }else{
          //invio a login s sito esterno
          let url = EitUrl.apiLoginGulliver + window.location.href; // + EitEnv.baseUrl + "/cart"; /*state.url*/;
          window.open(url,"_self"/*, "_blank"*/);
        }
      });

    }


  }

  ingredients(item) {
    var result = "";

    /*for (var iG = 0; iG < item.ingredients.length; iG++) {
      result += item.ingredients[iG].name;
      if (iG < item.ingredients.length - 1) {
        result += ", ";
      }
    }
*/
    return result;
  };

  shortDescr(item) {
    var result = "";

    /*if (item.descr.length > 0 && item.descr.length < 15) {
      result = " (" + item.descr + ")";
    }*/

    return result;
  }

  longDescr(item) {
    var result = "";

    /* if (item.descr.length > 15) {
       result = item.descr + " ";
     }*/

    return result;
  }

  goToPay() {
    this.router.navigate(['/checkpay'], { queryParams: {} });
  }



  addToCart(product: any) {
    //  this.productService.addToCart(product);
  }

  addToCartSingle(menuitem) {
    this.cartService.addToCartSingle(menuitem.id, 1, "", 1);
  }

  removeToCartSingle(menuitem) {
    this.cartService.removeToCartP(menuitem.id, 1, 1);
  }

  addToCartSlave(item: any, oid) {
    if (item != null) {
      this.cartService.addToCartSingleSlave(oid, item.id, 1, "", 1);
    }
  }

  removeToCartSlave(item: any, oid) {
    if (item != null) {
      this.cartService.removeToCartPslave(oid, item.id, 1, 1);
    }
  }

  goToCheckout() {
    console.log("go to checkout");
    if (!this.cartData.order.orderminverified && this.cartData.order.sovrapprezzononapplicabile){
      //ordine minimo non verificato!
      var msg = "Attenzione! Ordine minimo di " + this.cartData.order.ordineminimo +"� in prodotti non raggiunto!";
      this.toastService.error(msg);
    }else{
      this.router.navigate(['/checkout'], { queryParams: {} });
    }
  }

  removeTip() {

    console.log("remove tip");
    let tip = this.cartData.order.euro_tip;

    if (tip > 0) {
      tip--;
      this.cartService.updateTip(this.cartData, tip);
    }

  }

  addTip() {

    console.log("add tip");
    let tip = this.cartData.order.euro_tip;
    tip++;
    this.cartService.updateTip(this.cartData, tip);

  }

  opencouponmodal() {
    console.log("Inserisci coupon");
    var order: any;
    order = this.cartData.order;
    let modal = this.modalService.open(CouponModalComponent, { size: 'md', centered: true, ariaLabelledBy: 'Coupon-Modal', windowClass: 'coupon-modal' })
    modal.componentInstance.order = order
    modal.componentInstance.init()
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      if (event.status == RESPONSE.JPS_OK) {
        console.log("dismiss datetime response OK");
        //this.cartData.order.order_date = event.orario;
        //this.cartService.loadCart(this.cartData.order.id);
      } else {
        console.log("dismiss datetime response ERROR");
        //this.cartService.loadCart(this.cartData.order.id);
      }
    })
  }

  editOrderTime()
  {
    this.cartService.editOrderTime(this.cartData);
  }

  extrainfoclick()
  {
    console.log("extra info sovrapprezzo");
    var order: any;
    order = this.cartData.order;
    let modal = this.modalService.open(ExtrainfoComponent, { size: 'md', centered: true/*, ariaLabelledBy: 'Coupon-Modal', windowClass: 'coupon-modal' */})
    modal.componentInstance.order = order
    modal.componentInstance.init()
    modal.componentInstance.onDismiss.subscribe((event: any) => {
      /*
      if (event.status == RESPONSE.JPS_OK) {
        console.log("dismiss datetime response OK");
        
      } else {
        console.log("dismiss datetime response ERROR");
        //this.cartService.loadCart(this.cartData.order.id);
      }
      */
    })
  }

  /* 
  getPromoFDOM(item: any) {
    for (let i = 0; i < item.promos.length; i++) {
      if (item.promos[i][0].type_calc == 2) {
        return item.promos[i][0].order_min;
      }
    }
    return 0;
  }

  promoEuroMin()  {
    var result = -1;
    if(this.restaurant && this.cartData && this.cartData.order) {
      if(this.restaurant.has_free_delivery) {
        result = this.getPromoFDOM(this.restaurant) - this.cartData.order.euro_total;
      }
      else if(this.restaurant.has_promo) {
        result = this.restaurant.promos[0][0].order_min - this.cartData.order.euro_total;
      }
    }
    return result;
  }

  calcPercPromo(){
    let result = 0;
    let promo = this.restaurant && this.restaurant.promos && this.restaurant.promos.length && this.restaurant.promos[0].length ? this.restaurant.promos[0][0] : null;
    if(promo) {
      let om = this.restaurant.has_free_delivery ? this.getPromoFDOM(this.restaurant) : promo.order_min;
      result = 100 * this.cartData.order.euro_total / om;
    }
    
    if(result > 0) result = result < 100 ? Math.round(result/10) *10 : 100;

    return result;
  } */
}
